
import {
  Box,
  Page,
  VerticalStack,
  HorizontalGrid,
  Text,
  AlphaCard,
  Divider,
  TextField,
  Button,
  ButtonGroup,
  Form,
  InlineError,
  Image,
  HorizontalStack,
} from '@shopify/polaris'
import { useEffect, useState } from 'react'
import { AddressElement, useElements } from '@stripe/react-stripe-js';

import Layout from '../components/layout'
import { sendSupportEmail } from '../firebase';
import calendlyImage from '../assets/calendly-logo.png'
import checkmarkImage from '../assets/checkmark.svg'

// This example is for guidance purposes. Copying it will come with caveats.
export default function HelpAndSupport() {

  const elements = useElements()
  const [emailSent, setEmailSent] = useState(false)
  const [emailLoading, setEmailLoading] = useState(false)
  const [subject, setSubject] = useState('')
  const [message, setMessage] = useState('')
  const [error, setError] = useState(false)

  async function sendEmail() {
    setEmailLoading(true);
    setError(false)
    try {
      await sendSupportEmail({ subject, message })
      setEmailSent(true)
    } catch (e) {
      setError(true)
      console.error(e.message)
    } finally {
      setEmailLoading(false);
    }
  }

  useEffect(() => {
    console.log('destroying')
    if (elements?.getElement(AddressElement)) {
      console.log('destored')
      elements?.getElement(AddressElement)?.destroy()
    }
  }, [])

  return (
    <>
      <Layout>
        <Page
          title="Help & support"
          divider
        >
          <VerticalStack gap={{ xs: "8", sm: "4" }}>
            <HorizontalGrid columns={{ xs: "1fr", md: "2fr 5fr" }} gap="4">
              <Box
                as="section"
                paddingInlineStart={{ xs: 4, sm: 0 }}
                paddingInlineEnd={{ xs: 4, sm: 0 }}
              >
                <VerticalStack gap="4">
                  <Text as="h3" variant="headingMd">
                    Learn the Basics
                  </Text>
                  <Text as="p" variant="bodyMd">
                    Get started by watching our tutorial!
                  </Text>
                </VerticalStack>
              </Box>
              <AlphaCard>
                <Text variant="headingMd">Watch our tutorial</Text>
                <Image source={""} alt="Video here" height="300px" />
              </AlphaCard>
            </HorizontalGrid>
            <Divider />
            <HorizontalGrid columns={{ xs: "1fr", md: "2fr 5fr" }} gap="4">
              <Box
                as="section"
                paddingInlineStart={{ xs: 4, sm: 0 }}
                paddingInlineEnd={{ xs: 4, sm: 0 }}
              >
                <VerticalStack gap="4">
                  <Text as="h3" variant="headingMd">
                    Email Us
                  </Text>
                  <Text as="p" variant="bodyMd">
                    We'll get back to you as soon as possible via email
                  </Text>
                </VerticalStack>
              </Box>
              <AlphaCard roundedAbove="sm">
                {!emailSent ? (
                  <Form onSubmit={e => {
                    e.preventDefault();
                    sendEmail();
                  }}>
                    <VerticalStack gap="4">
                      <TextField label="Subject" onChange={v => setSubject(v)} value={subject} />
                      <TextField label="Message" onChange={v => setMessage(v)} value={message} multiline={3} />
                      {error && <InlineError message={"Could not send message. Try again, or refresh"} />}
                      <ButtonGroup>
                        <Button submit loading={emailLoading} primary disabled={!subject || !message}>Send</Button>
                      </ButtonGroup>
                    </VerticalStack>
                  </Form>
                ) : (
                  <VerticalStack gap="2">
                    <HorizontalStack blockAlign="center">
                      <Image width="30%" source={checkmarkImage} alt="Email sent" />
                      <VerticalStack gap="2">
                        <Text as="h3" variant="headingMd">
                          Email sent!
                        </Text>
                        <Text>
                          We'll get back to you as soon as possible
                        </Text>
                      </VerticalStack>
                    </HorizontalStack>
                  </VerticalStack>
                )
                }
              </AlphaCard>
            </HorizontalGrid>
            <Divider />
            <HorizontalGrid columns={{ xs: "1fr", md: "2fr 5fr" }} gap="4">
              <Box
                as="section"
                paddingInlineStart={{ xs: 4, sm: 0 }}
                paddingInlineEnd={{ xs: 4, sm: 0 }}
              >
                <VerticalStack gap="4">
                  <Text as="h3" variant="headingMd">
                    Book a 1:1 Demo
                  </Text>
                  <Text as="p" variant="bodyMd">
                    We'll show you how to get the most out of PartnerUp
                  </Text>
                </VerticalStack>
              </Box>
              <AlphaCard roundedAbove="sm">
                <Image width="30%" source={calendlyImage} />
                <ButtonGroup>
                  <Button url="https://calendly.com/partnerupnet/partnerup-customer-demo">Click here to Book a Demo</Button>
                </ButtonGroup>
              </AlphaCard>
            </HorizontalGrid>
          </VerticalStack>
        </Page>
      </Layout >
    </>
  )
}
